import { render, staticRenderFns } from "./url_type.vue?vue&type=template&id=684a8ff4&scoped=true&"
import script from "./url_type.vue?vue&type=script&lang=js&"
export * from "./url_type.vue?vue&type=script&lang=js&"
import style0 from "./url_type.vue?vue&type=style&index=0&id=684a8ff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a8ff4",
  null
  
)

export default component.exports